/* ==========================================================================
   Navigation dans la fenetre d'agrandissement des photos, sur telephone.

   POURQUOI. Sous 750 px, Dawn n'affiche qu'un seul visuel a la fois dans la
   fenetre : les autres sont masques par la regle
   « .product-media-modal__content > *:not(.active) { display: none } ».
   Il n'existait donc aucun moyen de passer d'une photo a la suivante une fois la
   fenetre ouverte, ni aucune indication du nombre de photos.

   La reference affiche en bas une pastille « ‹ 1 / 11 › ». On fait la meme
   chose. Sur ordinateur, Dawn empile tous les visuels et la fenetre se fait
   defiler normalement : la pastille y est inutile, elle reste masquee.

   COMMENT. On ne touche pas a product-modal.js, qui appartient a Dawn. On
   deplace simplement la classe « active » d'un visuel a l'autre, ce qui est
   exactement ce que fait Dawn a l'ouverture. Un observateur surveille l'attribut
   « open » de la fenetre pour remettre le compteur a jour quand elle s'ouvre sur
   une autre photo.
   ========================================================================== */

(function () {
  'use strict';

  var REQUETE_TELEPHONE = '(max-width: 749px)';

  function preparer(fenetre) {
    if (fenetre.yzavoNavigationPosee) return;

    var nav = fenetre.querySelector('[data-yzavo-modale-nav]');
    var contenu = fenetre.querySelector('.product-media-modal__content');
    if (!nav || !contenu) return;

    fenetre.yzavoNavigationPosee = true;

    var index = nav.querySelector('[data-yzavo-modale-index]');
    var total = nav.querySelector('[data-yzavo-modale-total]');
    var telephone = window.matchMedia(REQUETE_TELEPHONE);

    function visuels() {
      return Array.prototype.filter.call(contenu.children, function (e) {
        // Les photos de coloris sont masquees tant qu'une pastille de couleur
        // n'a pas ete choisie : elles ne comptent pas dans le defile.
        if (!e.hasAttribute('data-media-id')) return false;
        // Une photo de coloris ne compte que si elle a ete revelee.
        if (e.classList.contains('yzavo-media-coloris')) {
          return e.classList.contains('yzavo-coloris-visible');
        }
        return true;
      });
    }

    function position() {
      var liste = visuels();
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].classList.contains('active')) return i;
      }
      return 0;
    }

    function rafraichir() {
      var liste = visuels();
      if (total) total.textContent = liste.length;
      if (index) index.textContent = position() + 1;
      // Une seule photo, la pastille n'apprend rien.
      nav.hidden = liste.length < 2;
    }

    function aller(pas) {
      var liste = visuels();
      if (liste.length < 2) return;
      var courant = position();
      var suivant = (courant + pas + liste.length) % liste.length;
      liste[courant].classList.remove('active');
      liste[suivant].classList.add('active');
      // Sur ordinateur les visuels sont tous empiles : on amene le bon a l'ecran.
      if (!telephone.matches) liste[suivant].scrollIntoView({ block: 'center' });
      rafraichir();
    }

    nav.addEventListener('click', function (e) {
      var bouton = e.target.closest('[data-yzavo-modale]');
      if (!bouton) return;
      aller(bouton.dataset.yzavoModale === 'precedent' ? -1 : 1);
    });

    // Dawn ferme toute fenetre « media-modal » au premier pointerup de souris qui
    // s'y produit, sauf dans un deferred-media ou un product-model (global.js).
    // Sans cette interception, cliquer sur une fleche fermait la fenetre.
    ['pointerdown', 'pointerup', 'click'].forEach(function (type) {
      nav.addEventListener(type, function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!fenetre.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') aller(-1);
      if (e.key === 'ArrowRight') aller(1);
    });

    /* On fait glisser la photo au doigt, comme dans le carrousel de la fiche.
       Demande de Le proprietaire, remarque : « tu laisses les petites fleches, mais tu rajoutes le
       fait de scroller. »

       Seul le tactile est ecoute. A la souris, Dawn ferme la fenetre au premier
       pointerup (global.js) ; un glisser a la souris se terminerait donc par une
       fermeture, ce qui serait pire que de ne rien faire.

       Un mouvement plus vertical qu'horizontal est ignore : c'est un defilement
       de page, pas un changement de photo. */
    var DISTANCE_MINIMALE = 40;
    var REPIT_APRES_GLISSEMENT = 500;
    var departX = null;
    var departY = null;
    var dernierGlissement = 0;

    // Chrome fabrique des evenements de souris de compatibilite apres un
    // touchend. Dawn ferme la fenetre au premier pointerup de souris : on les
    // arrete en phase de capture, avant son ecouteur, juste apres un glissement.
    fenetre.addEventListener(
      'pointerup',
      function (e) {
        if (Date.now() - dernierGlissement < REPIT_APRES_GLISSEMENT) e.stopPropagation();
      },
      true
    );

    contenu.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) {
          departX = null;
          return;
        }
        departX = e.touches[0].clientX;
        departY = e.touches[0].clientY;
      },
      { passive: true }
    );

    contenu.addEventListener(
      'touchmove',
      function (e) {
        if (departX === null || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - departX;
        var dy = e.touches[0].clientY - departY;
        // Un mouvement horizontal appartient a la galerie. Sans ce refus, le
        // navigateur le comprend comme un retour a la page precedente.
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) e.preventDefault();
      },
      { passive: false }
    );

    contenu.addEventListener(
      'touchend',
      function (e) {
        if (departX === null || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - departX;
        var dy = e.changedTouches[0].clientY - departY;
        departX = null;
        if (Math.abs(dx) < DISTANCE_MINIMALE || Math.abs(dx) <= Math.abs(dy)) return;
        dernierGlissement = Date.now();
        aller(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    /* GESTE RETOUR. Sur telephone, beaucoup de visiteurs ferment la fenetre
       avec le geste ou le bouton « retour ». Sans entree dans l'historique, ce
       geste quittait la fiche et ramenait sur Google : 19 visites venues des
       annonces se terminent la fenetre ouverte (0406). A l'ouverture, on ajoute
       donc une entree a l'historique : « retour » ferme la fenetre et laisse le
       visiteur sur la fiche. Fermee autrement (croix, Echap, clic a cote),
       l'entree ajoutee est retiree pour que « retour » garde ensuite son sens. */
    var entreeAjoutee = false;
    var fermeeParRetour = false;

    window.addEventListener('popstate', function () {
      if (!entreeAjoutee) return;
      entreeAjoutee = false;
      if (fenetre.hasAttribute('open')) {
        fermeeParRetour = true;
        fenetre.hide();
      }
    });

    function suivreHistorique(ouverte) {
      if (ouverte) {
        if (entreeAjoutee) return;
        try {
          history.pushState({ yzavoGalerie: true }, '');
          entreeAjoutee = true;
        } catch (e) {}
        return;
      }
      if (fermeeParRetour) {
        fermeeParRetour = false;
        return;
      }
      if (entreeAjoutee) {
        entreeAjoutee = false;
        history.back();
      }
    }

    // Dawn choisit le visuel actif au moment de l'ouverture, apres avoir pose
    // l'attribut open. Le compteur se met donc a jour sur ce changement.
    new MutationObserver(function () {
      var ouverte = fenetre.hasAttribute('open');
      // Voir l'explication en tete : sans cette classe, un glissement vers la
      // droite ramene le visiteur a la page precedente.
      document.documentElement.classList.toggle('yzavo-modale-ouverte', ouverte);
      if (ouverte) setTimeout(rafraichir, 0);
      suivreHistorique(ouverte);
    }).observe(fenetre, { attributes: true, attributeFilter: ['open'] });

    rafraichir();
  }

  function poser() {
    document.querySelectorAll('product-modal').forEach(preparer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }
})();